/* unplugin-vue-components disabled */import { render } from "./OffPositionBizList.vue?vue&type=template&id=0f25d6d9&scoped=true"
import script from "./OffPositionBizList.vue?vue&type=script&lang=js"
export * from "./OffPositionBizList.vue?vue&type=script&lang=js"

import "./OffPositionBizList.vue?vue&type=style&index=0&id=0f25d6d9&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f25d6d9"]])

export default __exports__